import React, { useEffect, useState } from "react";
import { getImageDimensions } from "../../utils/getImageDimensions";
import { logger } from "../../utils/logger";
import ImgCaption from "./ImgCaption";

interface ImgFullWidthProps {
  caption?: string;
  cssClass?: string;
  elementId?: string;
  fileUrl?: string;
  url: string;
  type?: string;
}

const ImgFullWidth: React.FC<ImgFullWidthProps> = ({
  caption = "",
  cssClass = "mb--100",
  elementId = "",
  fileUrl = "",
  url,
  type,
}) => {
  const [singleImgSize, setSingleImgSize] = useState<string>("");
  useEffect(() => {
    async function fetchImageDimensions() {
      try {
        const dimensions = await getImageDimensions(url);
        if (dimensions.width < 1000 || type === "standardSmall") {
          setSingleImgSize("small-centered-img");
        } else if (type === "standardMedium") {
          setSingleImgSize("medium-centered-img");
        }
      } catch (error) {
        logger.error("Error fetching image dimensions:", error);
      }
    }

    fetchImageDimensions();
  }, [url, type]);

  return (
    <div id={elementId} className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="inner-wrapper">
            <div className="inner">
              <div className={`thumbnail ${cssClass}`}>
                {fileUrl !== "" ? (
                  <a href={fileUrl} target="_blank" rel="noreferrer">
                    <img
                      src={`${url}`}
                      className={`mb--40 ${singleImgSize}`}
                      alt="User uploads"
                    />
                    <ImgCaption caption={caption} />
                  </a>
                ) : (
                  <>
                    <img
                      src={`${url}`}
                      className={`mb--40 ${singleImgSize}`}
                      alt="User uploads"
                    />
                    <ImgCaption caption={caption} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImgFullWidth;
